function elementScrollTo(element, left, behavior) {
  requestAnimationFrame(() => {
    element.scrollTo({
      left: left,
      top: 0,
      behavior: behavior ? behavior : Themu.prefersReducedMotion ? 'instant' : 'smooth',
    });
  });
}

function removeTrapBodyScroll() {
  const scrollY = document.body.style.top;

  document.body.style.paddingRight = '';
  document.body.style.overflow = 'visible';
  document.body.style.touchAction = '';

  document.body.style.top = '';

  if (scrollY === '') {
    return;
  }

  window.scrollTo(0, parseInt(scrollY || '0') * -1);

  setTimeout(() => {
    document.dispatchEvent(new Event('ce-sticky-scroll-header:unfreeze'));
  }, 100);
}

function trapBodyScroll() {
  document.dispatchEvent(new Event('ce-sticky-scroll-header:freeze'));

  document.body.style.top = `-${window.scrollY}px`;

  document.body.style.paddingRight = `${window.innerWidth - document.body.offsetWidth}px`;
  document.body.style.overflow = 'hidden';
  document.body.style.touchAction = 'none';
}

(function () {
  window.Themu = window.Themu || {};

  function mediaQueryIsViewportDesktop() {
    const mediaQuery = window.matchMedia('(min-width: 768px)');
    mediaQuery.addEventListener('change', () => {
      Themu.isViewportDesktop = mediaQuery.matches;
    });

    return mediaQuery;
  }

  function mediaQueryPrefersReducedMotion() {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    mediaQuery.addEventListener('change', () => {
      Themu.prefersReducedMotion = mediaQuery.matches;
    });

    return mediaQuery;
  }

  window.Themu = {
    ...window.Themu,
    ...{
      animation: {
        easeIn: 'cubic-bezier(0, 0, 0.2, 1)',
        easeOut: 'cubic-bezier(0.4, 0, 1, 1)',
      },
      prefersReducedMotion: mediaQueryPrefersReducedMotion().matches,
      isViewportDesktop: mediaQueryIsViewportDesktop().matches,
    },
  };

  document.addEventListener('DOMContentLoaded', () => {
  const summary = document.querySelector('summary.button.button--primary[aria-controls="header__mobile-navigation"]');
  if (!summary) return;

  // Evita o "duplo toggle" do script do tema
  summary.addEventListener('click', (e) => {
    e.preventDefault();   // bloqueia toggle nativo do <summary>
    e.stopPropagation();  // evita que outro handler do tema dispare

    // Descobre o <details> do menu
    const targetId = summary.getAttribute('aria-controls');
    const target = document.getElementById(targetId);
    const details = summary.closest('details') || target?.closest('details') || target;

    if (!details) return;

    const isOpen = details.hasAttribute('open');
    if (isOpen) {
      details.removeAttribute('open');
      summary.setAttribute('aria-expanded', 'false');
    } else {
      details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
    }
  }, true); // captura = pega antes do handler do tema
});


  document.documentElement.className = document.documentElement.className.replace('no-js', 'js');
})();
